import React from "react";
import { Grid, Card, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const UploadConfig = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "50%",
        minHeight: "100vh",
        background: "transparent",
        color: "#fff",
        paddingX: 4,
        paddingY: 6
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: 600, letterSpacing: "1px" }}>
        Document Type <span style={{ color: "#FFD600" }}>▮▮▮</span>
      </Typography>
      <Typography variant="subtitle1" sx={{ marginTop: 0.5, color: "#bbb" }}>
        Defines the structure, purpose, and content of a document
      </Typography>
      <Grid container spacing={4} marginTop={2}>
        <Grid item xs={12} md={6}>
          <Card
            variant="outlined"
            sx={{
              backgroundColor: "transparent",
              color: "#fff",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              padding: 4,
              border: "1px solid #fff",
              height: 160,
              cursor: "pointer",
              transition: "box-shadow 0.2s",
              "&:hover": {
                boxShadow: "0 2px 12px rgba(255,255,255,0.1)"
              }
            }}
            onClick={() => navigate("/bulk-upload/parser")}
          >
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              Existing Document Type
            </Typography>
            <Typography variant="body2" sx={{ marginTop: 2, color: "#bbb" }}>
              Predefined or already-available categories or documents in a
              system
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card
            variant="outlined"
            sx={{
              backgroundColor: "transparent",
              color: "#fff",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              padding: 4,
              border: "1px solid #fff",
              height: 160,
              cursor: "pointer",
              transition: "box-shadow 0.2s",
              "&:hover": {
                boxShadow: "0 2px 12px rgba(255,255,255,0.1)"
              }
            }}
            onClick={() => navigate("/bulk-upload/new")}
          >
            <Typography variant="h6" sx={{ fontWeight: 500 }}>
              New Document Type
            </Typography>
            <Typography variant="body2" sx={{ marginTop: 2, color: "#bbb" }}>
              Custom-defined category of document that is added to a system
            </Typography>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UploadConfig;
